import { Circle, HStack } from "@chakra-ui/react";

type DotsProps = {
  length: number;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
};

const CarouselDotIndicators = ({
  length,
  activeIndex,
  setActiveIndex,
}: DotsProps) => {
  return (
    <HStack
      mx="auto"
      spacing="4"
      mt="8"
      color={"gray.300"}
      alignItems="center"
      justifyContent="center"
    >
      {new Array(length).fill("").map((_, i) => {
        const isActive = i === activeIndex;
        return (
          <Circle
            onClick={() => setActiveIndex(i)}
            key={i}
            size={{
              base: isActive ? 3 : 2,
              lg: isActive ? 4 : 3,
            }}
            bg={isActive ? "blue.500" : "currentcolor"}
            my="auto"
            display="inline-block"
            cursor="pointer"
            translateY="-50%"
          />
        );
      })}
    </HStack>
  );
};

export default CarouselDotIndicators;
